export default __webpack_public_path__ + "static/media/3.83d8bb65.jpg";